import { CLEAR_UNPAID_ORDERS_MODAL, SET_UNPAID_ORDERS_MODAL } from '../../actionTypes/unpaidOrdersModal'

export const setUnpaidModal = value => ({ type: SET_UNPAID_ORDERS_MODAL, value })
export const clearUnpaidModal = () => ({ type: CLEAR_UNPAID_ORDERS_MODAL })
